import { ChevronDown } from "lucide-react";
import { useState } from "react";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const ProductsActionsDropdown = ({ onButtonClick, selectedProduct }) => {
  const [isOpen, setIsOpen] = useState(false);

  // const buttons = [
  //   {
  //     id: "f1",
  //     component: "DeliveryOrder",
  //     label: "All D.O",
  //     fullLabel: "All Delivery Orders",
  //     button: "F1",
  //   },
  //   {
  //     id: "f2",
  //     component: "PendingOrder",
  //     label: "Pending Order",
  //     fullLabel: "Pending Orders",
  //     button: "F2",
  //   },
  //   {
  //     id: "f3",
  //     component: "Quotations",
  //     label: "Quotations",
  //     fullLabel: "Quotations",
  //     button: "F3",
  //   },
  //   {
  //     id: "f4",
  //     component: "OrderRequest",
  //     label: "Order request",
  //     fullLabel: "Order Request",
  //     button: "F4",
  //   },
  //   {
  //     id: "f5",
  //     component: "SalesOrder",
  //     label: "Pending S.O",
  //     fullLabel: "Sales Orders",
  //     button: "F5",
  //   },
  //   {
  //     id: "f6",
  //     component: "Sales",
  //     label: "Sales",
  //     fullLabel: "Sales",
  //     button: "F6",
  //   },
  //   {
  //     id: "f7",
  //     component: "SalesmanRequest",
  //     label: "Salesman Request",
  //     fullLabel: "Salesman Request",
  //     button: "F7",
  //   },
  //   {
  //     id: "f8",
  //     component: "Purchase",
  //     label: "Purchase",
  //     fullLabel: "Purchase",
  //     button: "F8",
  //   },
  //   {
  //     id: "f9",
  //     component: "AllTransactions",
  //     label: "All Transaction",
  //     fullLabel: "All Transaction",
  //     button: "F9",
  //   },
  //   {
  //     id: "f10",
  //     component: "Claim",
  //     label: "Claim",
  //     fullLabel: "Claim",
  //     button: "F10",
  //   },
  //   {
  //     id: "f11",
  //     component: "QuotationTrack",
  //     label: "Quotations Track",
  //     fullLabel: "Quotation Track",
  //     button: "F11",
  //   },
  //   {
  //     id: "f12",
  //     component: "Transit",
  //     label: "Transit",
  //     fullLabel: "Transit",
  //     button: "F12",
  //   },
  // ];

  const buttons = [
    {
      id: "f1",
      component: "SalesOrder",
      label: "Sales Order Pending",
      fullLabel: "Sales Order Pending",
      button: "F1",
    },
    {
      id: "f2",
      component: "DeliveryOrder",
      label: "Delivery Order Pending",
      fullLabel: "Delivery Order Pending",
      button: "F2",
    },
    {
      id: "f3",
      component: "Itemdetails",
      label: "Item details with modification",
      fullLabel: "Item details with modification",
      button: "F3",
    },
    {
      id: "f4",
      component: "OrderRequest",
      label: "Order request",
      fullLabel: "Order Request",
      button: "F4",
    },

    {
      id: "f7",
      component: "Sales",
      label: "Sales History",
      fullLabel: "Sales History",
      button: "F7",
    },
    {
      id: "f8",
      component: "Purchase",
      label: "Purchase History",
      fullLabel: "Purchase History",
      button: "F8",
    },
    {
      id: "f9",
      component: "AllTransactions",
      label: "Complete Transaction History",
      fullLabel: "Complete Transaction History",
      button: "F9",
    },
    {
      id: "f11",
      component: "QuotationHistory",
      label: "Quotation History",
      fullLabel: "Quotation History",
      button: "F11",
    },
  ];

  // Map function keys to access keys for permission check
  const accessKeyAndFunctionKeyMap = {
    F1: "",
    F2: "JT",
    F4: "JS",
    F7: "JO",
    F8: "JN",
    F9: "JV",
    F11: "JU",
  };

  const handleButtonClick = (button, isDisabled) => {
    if (isDisabled) return;
    if (!selectedProduct) {
      alert("Please select a product first");
      return;
    }
    onButtonClick(button);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        disabled={!selectedProduct}
        className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
          selectedProduct
            ? "bg-green-50 text-green-700 border border-green-200 hover:bg-green-100"
            : "bg-gray-50 text-gray-400 border border-gray-200 cursor-not-allowed"
        }`}
      >
        Actions
        <ChevronDown
          className={`w-4 h-4 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && selectedProduct && (
        <div className="absolute top-full left-0 mt-1 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto">
          <div className="py-1">
            {buttons.map((button) => {
              // Determine if this button should be disabled based on access
              const accessKey = accessKeyAndFunctionKeyMap[button.button];
              const hasAccess =
                accessKey === ""
                  ? true
                  : accessKey
                    ? canUserSeeThis(accessKey)
                    : true;
              const isDisabled = !hasAccess;
              return (
                <button
                  key={button.Code}
                  onClick={() => handleButtonClick(button, isDisabled)}
                  disabled={isDisabled}
                  className={`w-full px-4 py-2 text-left text-sm flex items-center justify-between group transition-colors
                    ${
                      isDisabled
                        ? "text-gray-400 bg-gray-50 cursor-not-allowed"
                        : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    }
                  `}
                >
                  <span>{button.fullLabel}</span>
                  <span
                    className={`bg-blue-600 text-white px-1.5 py-0.5 rounded text-xs font-bold ${isDisabled ? "opacity-40" : ""}`}
                  >
                    {button.button}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
      )}
    </div>
  );
};
export default ProductsActionsDropdown;
